/**
 *  @class
 *  @function Predictive Search
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.predictiveSearchCollections = this.querySelector('.thb-predictive-search-collections');
      this.predictiveSearchWrapper = this.querySelector('.thb-predictive-search-wrapper');
      this.cc = this.querySelector('.searchform--click-capture');

      this.setupEventListeners();

    }
    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.predictiveSearchResults.addEventListener('focusout', this.close.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.cc.addEventListener('click', this.close.bind(this));

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
      this.input.addEventListener('focus', this.open.bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        document.body.classList.remove('open-search');
        if (this.predictiveSearchWrapper) {
          this.predictiveSearchWrapper.classList.remove('has-search-term');
        }
        this.predictiveSearchResults.setAttribute('inert', '');
        this.predictiveSearchResults.classList.remove('has-search-term');
        if (this.predictiveSearchCollections) {
          this.predictiveSearchCollections.setAttribute('inert', '');
          this.predictiveSearchCollections.classList.remove('has-search-term');
        }
        return;
      }
      document.body.classList.add('open-search');
      if (this.predictiveSearchWrapper) {
        this.predictiveSearchWrapper.classList.add('has-search-term');
      }
      this.predictiveSearchResults.removeAttribute('inert');
      this.predictiveSearchResults.classList.add('has-search-term');
      if (this.predictiveSearchCollections) {
        this.predictiveSearchCollections.removeAttribute('inert');
        this.predictiveSearchCollections.classList.add('has-search-term');
      }
      this.getSearchResults(searchTerm);
      this.getCollectionResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        return;
      }

      this.getSearchResults(searchTerm);
      this.getCollectionResults(searchTerm);
    }

    getSearchResults(searchTerm) {

      this.predictiveSearchResults.classList.add('loading');

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    getCollectionResults(searchTerm) {
      if (!this.predictiveSearchCollections) return;

      this.predictiveSearchCollections.classList.add('loading');

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=collection&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search-collections`)
        .then((response) => {
          this.predictiveSearchCollections.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-collections').innerHTML;

          this.renderCollectionResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      let submitButton = this.querySelector('#search-results-submit');

      if (submitButton) {
        submitButton.addEventListener('click', () => {
          this.form.submit();
        });
      }
    }

    renderCollectionResults(resultsMarkup) {
      if (this.predictiveSearchCollections) {
        this.predictiveSearchCollections.innerHTML = resultsMarkup;
        
        // Ocultar el panel si no hay resultados
        const container = this.predictiveSearchCollections.querySelector('.thb-predictive-search--container');
        if (container && container.dataset.hasResults === 'false') {
          this.predictiveSearchCollections.setAttribute('inert', '');
          this.predictiveSearchCollections.classList.remove('has-search-term');
        }

        // Agregar evento al botón de ver todos los resultados en colecciones
        let submitButtonCollections = this.predictiveSearchCollections.querySelector('#search-results-submit-collections');
        if (submitButtonCollections) {
          submitButtonCollections.addEventListener('click', () => {
            this.form.submit();
          });
        }
      }
    }

    close() {
      if (this.predictiveSearchWrapper) {
        this.predictiveSearchWrapper.classList.remove('has-search-term');
      }
      this.predictiveSearchResults.setAttribute('inert', '');
      this.predictiveSearchResults.classList.remove('has-search-term');
      if (this.predictiveSearchCollections) {
        this.predictiveSearchCollections.setAttribute('inert', '');
        this.predictiveSearchCollections.classList.remove('has-search-term');
      }
      document.body.classList.remove('open-search');
    }
    open() {
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
      // El panel de colecciones solo se abre cuando hay un término de búsqueda (en onChange)
    }
  }
  customElements.define('search-form', SearchForm);
}